import { useMemo } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { CardStatus } from '../../shared'

/**
 * Translations map for each charging card status.
 *
 * Extracted because it is used in multiple places in the codebase:
 *
 * - when displaying status translation in the Charging Card table, inside the status chip
 * - when defining the sorting logic for the Charging Card table because statuses can
 *   have different alphabetical order when translated
 */
export const useChargingCardStatusLabelMap = (): Record<CardStatus, string> => {
  const { t } = useCustomTranslation()

  const labelMap: Record<CardStatus, string> = useMemo(
    () => ({
      ACTIVE: t('emobility.chargingCards.status.ACTIVE'),
      INACTIVE: t('emobility.chargingCards.status.INACTIVE'),
      REJECTED: t('emobility.chargingCards.status.REJECTED'),
      EXPIRED: t('emobility.chargingCards.status.EXPIRED'),
    }),
    [t]
  )

  return labelMap
}
